import { render, staticRenderFns } from "./FanTypeModal.vue?vue&type=template&id=2c85a515"
import script from "./FanTypeModal.vue?vue&type=script&lang=js"
export * from "./FanTypeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports